import html from '../assets/skills/html.svg';
import css from '../assets/skills/css.svg';
import javascript from '../assets/skills/javascript.svg';
import react from '../assets/skills/react.svg';
import redux from '../assets/skills/redux.svg';
import nextjs from '../assets/skills/nextjs.svg';
import tailwind from '../assets/skills/tailwind.svg';
import nodejs from '../assets/skills/nodejs.svg';
import express from '../assets/skills/express-dark.svg';
import postgresql from '../assets/skills/postgresql.svg';
import mongodb from '../assets/skills/mongodb.svg';
import python from '../assets/skills/python.svg';
import c_sharp from '../assets/skills/c-sharp.svg';
import dotnet from '../assets/skills/dotnet.svg';

export const skillList = [
  { name: 'HTML', icon: html },
  { name: 'CSS', icon: css },
  { name: 'JavaScript', icon: javascript },
  { name: 'React', icon: react },
  { name: 'Redux', icon: redux },
  { name: 'Next.js', icon: nextjs },
  { name: 'Tailwind CSS', icon: tailwind },
  { name: 'Node.js', icon: nodejs },
  { name: 'Express', icon: express },
  { name: 'PostgreSQL', icon: postgresql },
  { name: 'MongoDB', icon: mongodb },
  { name: 'Python', icon: python },
  { name: 'C#', icon: c_sharp },
  { name: '.NET', icon: dotnet },
];